import { ActionFooterWithMenu } from '../shared/ActionFooterWithMenu';

interface ActionFooterProps {
    canApprove: boolean;
    canRequestRevision: boolean;
    isSubmitting: boolean;
    onApprove: () => void;
    onRequestRevision: () => void;
    onDecline: () => void;
}

/**
 * Pinned action row at the bottom of the right sidebar.
 * Approve is the primary CTA (full-width pill) - disabled until the GP has
 * picked an aligner option AND ticked the acknowledgement.
 * Secondary actions (Request revision, Decline) live behind an overflow
 * (kebab) button so the visual hierarchy puts approval first.
 */
export function ActionFooter({
    canApprove,
    canRequestRevision,
    isSubmitting,
    onApprove,
    onRequestRevision,
    onDecline
}: ActionFooterProps) {
    return (
        <ActionFooterWithMenu
            primaryLabel="Approve case →"
            primaryDisabledLabel="Pick aligner + acknowledge to approve"
            canSubmit={canApprove}
            isSubmitting={isSubmitting}
            onSubmit={onApprove}
            menuWidthClass="w-96"
            menuActions={[
                {
                    label: 'Request changes',
                    onClick: onRequestRevision,
                    tone: 'amber',
                    hidden: !canRequestRevision
                },
                { label: 'Decline case', onClick: onDecline, tone: 'red' }
            ]}
        />
    );
}
